import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Form from '../../../components/form/Form.component'
import { FormValue, FormPage, FormSection, FormElement } from '../../../components/form/Form.types'
import { getSpecialReportDataOptionsSelector } from '../../options/selectors'
import { getSpecialReportsSelector } from '../selectors'
import { saveSpecialReport, setCustomQuestions } from '../store/specialReports.actions'
import { ICustomQuestion, questionTypeLookup } from '../store/specialReports.types'
import { IonItemDivider, IonLabel, IonList } from '@ionic/react'
import { useTranslation } from 'react-i18next'

const Questions: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const specialReportOptions = useSelector(getSpecialReportDataOptionsSelector)
  const { specialReportData } = specialReportOptions
  const specialReportsState = useSelector(getSpecialReportsSelector)
  const { customQuestions, categories } = specialReportsState

  const selectedCategoryId = categories[0]?.elementId

  const specialReport = specialReportData?.find(
    (f: any) =>
      f.formId.toString() === selectedCategoryId &&
      f.pages?.some((p: FormPage) => p.sections?.some((s: FormSection) => s.elements?.length > 0))
  )

  const getInitialFormValue = (): FormValue => {
    if (!customQuestions || customQuestions.length === 0) {
      return {}
    }
    const formValue: FormValue = {}
    customQuestions.forEach((q: ICustomQuestion) => {
      formValue[q.questionId] = q.answerId
    })
    return formValue
  }

  const [form, setForm] = useState<FormValue>(getInitialFormValue)

  const getFieldType = (ci: string): number => {
    return questionTypeLookup[ci]
  }

  const handleFormChange = (nextForm: FormValue) => {
    setForm(nextForm)

    if (!specialReportData) return

    const questions: ICustomQuestion[] = []

    specialReport.pages?.forEach((page: FormPage) =>
      page.sections?.forEach((section: FormSection) =>
        section.elements?.forEach((element: FormElement) => {
          const elementId = element.elementId
          const value = nextForm[elementId]
          const fieldType = getFieldType(element.componentInterface)
          let answerValue

          if (value == null || value === '' || (Array.isArray(value) && value.length === 0)) return

          if (Array.isArray(value)) {
            value.forEach((v) => {
              questions.push({
                questionId: elementId,
                question: element.label,
                answerId: v,
                fieldType: fieldType,
              })
            })
            return
          } else if (typeof value === 'object') {
            answerValue = value
          } else {
            answerValue = String(value)
          }

          questions.push({
            questionId: elementId,
            question: element.label,
            answerId: answerValue,
            fieldType: fieldType,
          })
        })
      )
    )

    dispatch(setCustomQuestions(questions))
    dispatch(saveSpecialReport())
  }

  return (
    <>
      {specialReport === undefined && (
        <IonList>
          <IonItemDivider color='light' className='ion-padding'>
            <IonLabel className='grid-item-divider-label' color='medium'>
              {t('specialReports.noFormQuestions')}
            </IonLabel>
          </IonItemDivider>
        </IonList>
      )}
      {specialReport && (
        <Form
          data={specialReport}
          value={form}
          onChange={handleFormChange}
          className='dynamic-form-section'
          filter={{ level: 'element', key: 'categoryId', value: selectedCategoryId }}
        />
      )}
    </>
  )
}

export default Questions
